"use client";
import { categoryLabel } from "@/lib/analytics";
import { formatMoney } from "@/lib/format";
import type { StartupRecord } from "@/lib/types";

function growthClass(growth: number | null): string {
  if (growth === null || growth === 0) return "ticker-mrr ticker-mrr--neutral";
  return growth > 0 ? "ticker-mrr ticker-mrr--up" : "ticker-mrr ticker-mrr--down";
}

function growthText(growth: number | null): string {
  if (growth === null) return "Flat";
  if (growth === 0) return "0.0%";
  return `${growth > 0 ? "+" : ""}${growth.toFixed(1)}%`;
}

type Props = {
  startup: StartupRecord;
  onClear?: () => void;
  showClear?: boolean;
};

export function TickerItem({ startup, onClear, showClear }: Props) {
  const content = (
    <>
      <div className="ticker-startup">
        {startup.icon ? (
          <img
            src={startup.icon}
            alt=""
            className="ticker-logo"
            width={24}
            height={24}
          />
        ) : (
          <span className="ticker-logo-placeholder" aria-hidden>
            {startup.name.slice(0, 1).toUpperCase()}
          </span>
        )}
        <span className="ticker-name">{startup.name}</span>
      </div>

      <span className="ticker-badge">{categoryLabel(startup.category)}</span>

      <div className="ticker-metrics">
        <span className={growthClass(startup.growth_30d)}>
          {formatMoney(startup.mrr)}
        </span>
        <span className="ticker-growth">{growthText(startup.growth_30d)}</span>
      </div>

      {showClear && onClear && (
        <button
          type="button"
          className="ticker-item-clear"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onClear();
          }}
          aria-label="Clear selection"
        >
          ×
        </button>
      )}
    </>
  );

  return (
    <a
      href={startup.trustmrr_url}
      target="_blank"
      rel="noopener noreferrer"
      className="ticker-item"
    >
      {content}
    </a>
  );
}
